export const sex = {
  1: "남",
  2: "여",
};

export const sexList = [
  {
    id: "1",
    name: "남",
  },
  {
    id: "2",
    name: "여",
  },
];

export const maritalStatus = {
  1: "미혼",
  2: "기혼",
};

export const maritalStatusList = [
  {
    id: "1",
    name: "미혼",
  },
  {
    id: "2",
    name: "기혼",
  },
];

export const cmSvc = {
  1: "군필",
  2: "미필",
  3: "면제",
  4: "병역특례",
  5: "해당없음",
};

export const cmSvcList = [
  {
    id: "1",
    name: "군필",
  },
  {
    id: "2",
    name: "미필",
  },
  {
    id: "3",
    name: "면제",
  },
  {
    id: "4",
    name: "병역특례",
  },
  {
    id: "5",
    name: "해당없음",
  },
];

export const militaryCat = {
  1: "육군",
  2: "해군",
  3: "공군",
  4: "해병",
  5: "KATUSA",
  6: "ROTC",
};

export const militaryCatList = [
  {
    id: "1",
    name: "육군",
  },
  {
    id: "2",
    name: "해군",
  },
  {
    id: "3",
    name: "공군",
  },
  {
    id: "4",
    name: "해병",
  },
  {
    id: "5",
    name: "KATUSA",
  },
  {
    id: "6",
    name: "ROTC",
  },
];

export const dcDiv = {
  1: "만기전역",
};

export const dcDivList = [
  {
    id: "1",
    name: "만기전역",
  },
];

export const pathEnt = {
  1: "공채",
  2: "상시",
  3: "추천",
};

export const pathEntList = [
  {
    id: "1",
    name: "공채",
  },
  {
    id: "2",
    name: "상시",
  },
  {
    id: "3",
    name: "추천",
  },
];

export const reasonL = {
  1: "근로자 자진 퇴사",
  2: "권소사직",
  3: "해고",
  4: "계약기간 만료",
};

export const reasonLList = [
  {
    id: "1",
    name: "근로자 자진 퇴사",
  },
  {
    id: "2",
    name: "권고사직",
  },
  {
    id: "3",
    name: "해고",
  },
  {
    id: "4",
    name: "계약기간 만료",
  },
];

export const kFormList = [
  {
    id: "1",
    name: "정규직",
  },
  {
    id: "2",
    name: "계약직",
  },
];

export const kForm = {
  1: "정규직",
  2: "계약직",
};

export const NYList = [
  {
    id: "1",
    name: "예",
  },
  {
    id: "0",
    name: "아니오",
  },
];

export const saCatList = [
  {
    id: "1",
    name: "시급",
  },
  {
    id: "2",
    name: "월급",
  },
  {
    id: "3",
    name: "연봉",
  },
];

export const tfAlwList = [
  {
    id: "1",
    name: "기본급",
  },
  {
    id: "2",
    name: "식대 (월)",
  },
  {
    id: "3",
    name: "연구활동비 (월)",
  },
  {
    id: "4",
    name: "자가운전보조금 (월)",
  },
  {
    id: "5",
    name: "출산보육수당 (월)",
  },
];

export const tfAlw = {
  1: "기본급",
  2: "식대 (월)",
  3: "연구활동비 (월)",
  4: "자가운전보조금 (월)",
  5: "출산보육수당 (월)",
};

export const otrAlwList = [
  {
    id: "1",
    name: "연장수당",
  },
  {
    id: "2",
    name: "휴일수당",
  },
  {
    id: "3",
    name: "야간수당",
  },
  {
    id: "4",
    name: "성과급",
  },
  {
    id: "5",
    name: "상여금",
  },
  {
    id: "6",
    name: "주휴수당",
  },
  {
    id: "9",
    name: "기타 과세수당",
  },
];

export const classifAcademicBgdList = [
  {
    id: "1",
    name: "고등학교",
  },
  {
    id: "2",
    name: "전문대학교",
  },
  {
    id: "3",
    name: "대학교",
  },
  {
    id: "4",
    name: "대학원 (석사)",
  },
  {
    id: "5",
    name: "대학원 (박사)",
  },
  {
    id: "6",
    name: "대학원 (기타)",
  },
];

export const classifAcademicBgd = {
  1: "고등학교",
  2: "전문대학교",
  3: "대학교",
  4: "대학원 (석사)",
  5: "대학원 (박사)",
  6: "대학원 (기타)",
};

export const graduationStatusList = [
  {
    id: "1",
    name: "재학중",
  },
  {
    id: "2",
    name: "졸업예정",
  },
  {
    id: "3",
    name: "졸업",
  },
  {
    id: "4",
    name: "수료",
  },
  {
    id: "5",
    name: "검정고시",
  },
  {
    id: "6",
    name: "중퇴",
  },
];

export const graduationStatus = {
  1: "재학중",
  2: "졸업예정",
  3: "졸업",
  4: "수료",
  5: "검정고시",
  6: "중퇴",
};

export const classifMajList = [
  {
    id: "1",
    name: "부전공",
  },
  {
    id: "2",
    name: "복수전공",
  },
  {
    id: "3",
    name: "이중전공",
  },
];

export const reasonLListOfCareer = [
  {
    id: "1",
    name: "업직종 전환",
  },
  {
    id: "2",
    name: "근무조건",
  },
  {
    id: "3",
    name: "경영악화",
  },
  {
    id: "4",
    name: "계약만료",
  },
  {
    id: "5",
    name: "출산/육아",
  },
  {
    id: "6",
    name: "학업",
  },
  {
    id: "7",
    name: "유학",
  },
  {
    id: "8",
    name: "개인사정",
  },
];

export const saUnitList = [
  {
    id: "1",
    name: "만원",
  },
  {
    id: "2",
    name: "달러",
  },
  {
    id: "3",
    name: "엔",
  },
];

export const saUnit = {
  1: "만원",
  2: "달러",
  3: "엘",
};

export const recogExpList = [
  {
    id: "1",
    name: "인정",
  },
  {
    id: "0",
    name: "미인정",
  },
];

export const recogExp = {
  1: "인정",
  0: "미인정",
};

export const passCatList = [
  {
    id: "1",
    name: "1차합격",
  },
  {
    id: "2",
    name: "2차합격",
  },
  {
    id: "3",
    name: "필기합격",
  },
  {
    id: "4",
    name: "실기합격",
  },
  {
    id: "5",
    name: "최종합격",
  },
];

export const passCat = {
  1: "1차합격",
  2: "2차합격",
  3: "필기합격",
  4: "실기합격",
  5: "최종합격",
};

export const PRJ_TPList = [
  {
    id: "1",
    name: "의약품",
  },
  {
    id: "2",
    name: "의료기기",
  },
];

export const PRJ_TP = {
  1: "의약품",
  2: "의료기기",
};
